import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";
// import variableEffects from '@/base/global/variables/figma.effects.json';

export const stepsThemeToken: any = {
  //====================================== COLOR =====================================//
  iconFinishColor: variableColors["ColorFigmaFunctionalSuccess50"],
  colorSplit: variableColors["ColorFigmaNeutralGrayscaleGray40"],
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDescription: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorTextDisabled: variableColors["ColorFigmaNeutralGrayscaleGray40"],

  //====================================== SIZE ======================================//
  iconSize: 28,
  iconSizeSM: 28,
  titleLineHeight: 32,
  dotSize: 20,
  dotCurrentSize: 20,
  padding: 32,
  paddingSM: 32,
  controlHeightSM: 28,

  //====================================== FONT ======================================//
  fontSize: variableTypography["BodyH300FontSize"],
  titleFontWeight: variableTypography["BodyH300FontWeight"],
  lineHeight: variableTypography["BodyH300LineHeight"],
  fontSizeDescription: variableTypography["BodyLargeFontSize"],
};
